$(document).ready(function () {

    $('.articleList__item.collapsable').on('click','.articleList__view-more',  function(){
        $(this).parent().removeClass('collapsed');
        $(this).remove();
    })

})